/**
 * DIV-043 — a private reference to the bundled jQuery's `.ajax`, captured at
 * module load.
 *
 * DIV-004 moved every internal call site onto the bundled jQuery instance
 * (`import $ from "jquery"`) so a theme's own jQuery (any version, absent,
 * or loaded late) can no longer affect CPC. It did not anticipate a THIRD
 * PARTY reaching the bundled instance itself: DIV-001's `window.jQuery`
 * bridge (compat/jquery-fallback.ts) is still installed, outward-only, on
 * any store whose theme ships no jQuery of its own — and on exactly those
 * stores `window.jQuery` IS the bundled `$`, not a copy. An app that patches
 * `window.jQuery.ajax` (Crisp session_791d72df, PBS Direct: the Easy Bundle
 * / Gift Box Builder app's `gbbMix` script does this) is therefore patching
 * the very function CPC's own add-to-cart calls through `$.ajax(...)` —
 * breaking price-token creation before the priced variant is built, so the
 * loader spins and the customer never gets added to cart. It only hits
 * stores where the DIV-001 bridge installed the bundled copy as
 * `window.jQuery` AND a hook like this loads after that point, which is why
 * it's intermittent/load-order-dependent rather than universal.
 *
 * Reading `$.ajax` at call time always gets "whichever function currently
 * sits on the shared object" — exactly what a later `window.jQuery.ajax =
 * wrapped` reassignment replaces. Capturing the reference here, once, at
 * this module's own evaluation (part of calculator.js's synchronous
 * top-level execution, before any later-loaded script gets a turn), means
 * CPC always calls the pristine original jQuery implementation no matter
 * what gets reassigned onto `$.ajax` afterward — immune to load order.
 * `.bind($)` preserves the `this` jQuery's internals expect, the same as
 * calling `$.ajax(...)` directly would.
 *
 * The DIV-001 bridge itself is deliberately left installed (NOJQ-001-v2
 * golden-pinned, possibly store-relied-upon) — this file does not touch it.
 */
import $ from "jquery";

const originalAjax = $.ajax.bind($);

/** Always the pristine jQuery `.ajax`, regardless of what `$.ajax` is reassigned to later. */
export function cpcAjax(settings: any): any {
  return originalAjax(settings);
}
